import { siteConfig } from "../utils/config";
import { formatPhoneNumber } from "../utils/formatters";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-green-800 text-white pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="mb-6 md:mb-0 md:col-span-2">
            <div className="flex items-center">
              <img
                src="/logo.png"
                alt="Shingle Guard Logo"
                className="h-8 w-8"
              />
              <h3 className="ml-2 text-xl heading-tertiary font-medium font-heading">
                Shingle
                <span className="text-accent font-medium font-heading">
                  Guard
                </span>
              </h3>
            </div>
            <p className="text-gray-100 mt-4 text-sm max-w-xs">
              Professional roofing services with quality craftsmanship and
              exceptional customer service.
            </p>
            <div className="mt-4">
              <a
                href="/contact"
                className="inline-flex items-center px-6 py-2.5 border border-transparent text-sm body-text rounded-full shadow-md text-dark-green-800 bg-accent hover:bg-yellow-500 transition-all duration-300 hover:scale-105 hover:-translate-y-1"
              >
                Get Free Estimate
              </a>
            </div>
          </div>

          {/* Main Pages */}
          <div className="lg:col-span-1">
            <h3 className="text-lg heading-tertiary mb-4 text-white">
              Main Pages
            </h3>
            <ul className="text-gray-100 text-sm space-y-3">
              <li>
                <a
                  href="/"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/how-it-works"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="/why-us"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  Why Us
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg heading-tertiary mb-4 text-white">
              Resources
            </h3>
            <ul className="text-gray-100 text-sm space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg heading-tertiary mb-4 text-white">
              Contact Us
            </h3>
            <ul className="text-gray-100 text-sm space-y-3">
              <li className="flex items-start">
                <svg
                  className="h-5 w-5 text-accent mt-0.5 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href={`tel:${formatPhoneNumber(siteConfig.contactPhone)}`}
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  {formatPhoneNumber(siteConfig.contactPhone)}
                </a>
              </li>
              <li className="flex items-start">
                <svg
                  className="h-5 w-5 text-accent mt-0.5 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href={`mailto:${siteConfig.contactEmail}`}
                  className="text-gray-100 hover:text-accent transition-colors"
                >
                  {siteConfig.contactEmail}
                </a>
              </li>
              <li className="flex items-start">
                <svg
                  className="h-5 w-5 text-accent mt-0.5 mr-2 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <p className="text-gray-100 flex-shrink">
                  {siteConfig.contactAddress}
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-8 border-t border-dark-green-700 text-center text-gray-100 text-sm">
          <p>© {currentYear} Shingle Guard Roofing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
